<template>
  <div class="discover-loyalty-products md:bg-neutral-50 md:py-10">
    <div class="max-w-946">
      <div class="px-4 mb-6 md:text-center">
        <p class="o-body font-bold text-newBlue-400 mb-2" v-text="$t('LandingsPage.ReferredByPage.DiscoverLoyaltyProducts.Description')" />
        <p class="o-heading-2 text-neutral-800" v-text="$t('LandingsPage.ReferredByPage.DiscoverLoyaltyProducts.Title')" />
        <div class="bg-newBlue-400 spacer w-10 rounded mt-2 md:mx-auto" />
      </div>
      <div
        ref="scrollContainer"
        class="flex overflow-x-scroll disable-scrollbars horizontal-scroll pr-6 md:pr-0"
        tabindex="0"
        role="region"
        aria-label="Loyalty products"
        @keydown.left="scrollLeft"
        @keydown.right="scrollRight"
      >
        <div
          v-for="(product, i) in products"
          :key="`${product.title}-${i}`"
          class="flex-1 horizontal-scroll-start"
          :class="{
            'pl-9': i !== 0,
            'pl-4 md:pl-0': i === 0
          }"
        >
          <div class="rounded flex justify-center">
            <OImage
              v-bind="product.image"
              img-class="rounded"
              :alt="$t('Accessibilty.AltTags.PhotoOfProductWithName', { name: product.title })"
            />
          </div>
          <p class="pt-4 o-heading-5 text-center" v-text="product.title" />
          <p class="o-body text-center mt-6 md:px-4" v-text="product.description" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImagePaths } from '@/utils/general'
import OImage from '@/components/OImage'

export default {
  name: 'DiscoverLoyaltyProducts',
  components: { OImage },
  props: {
    isWomenCountry: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    products () {
      const path = 'LandingsPage.ReferredByPage.DiscoverLoyaltyProducts.MenProducts'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      const products = items.map((_, i) => ({
        image: getImagePaths({
          path: this.$t(`${path}[${i}].Url`),
          s3: true
        }),
        title: this.$t(`${path}[${i}].Title`, { ...this.variables }),
        description: this.$t(`${path}[${i}].Description`, { ...this.variables })
      }))

      if (this.isWomenCountry) {
        return [products[0], products[1], this.womenProducts[0], products[2]]
      }

      return products
    },
    womenProducts () {
      const path = 'LandingsPage.ReferredByPage.DiscoverLoyaltyProducts.WomenProducts'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      const products = items.map((_, i) => ({
        image: getImagePaths({
          path: this.$t(`${path}[${i}].Url`),
          s3: true
        }),
        title: this.$t(`${path}[${i}].Title`, { ...this.variables }),
        description: this.$t(`${path}[${i}].Description`, { ...this.variables })
      }))

      return products
    }
  },
  methods: {
    scrollLeft () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft -= 200 // Adjust scroll amount as needed
      }
    },
    scrollRight () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft += 200 // Adjust scroll amount as needed
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.discover-loyalty-products {
  .oimage >>> img {
    max-width: unset;
  }

  .horizontal-scroll {
    @apply overflow-x-scroll;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;

    &-start {
      scroll-snap-align: start;
    }
  }

  .max-w-946 {
    @apply mx-auto;
    max-width: 94.6rem;
  }

  .spacer {
    height: .2rem;
  }
}

/* Add visual indication of focus */
.horizontal-scroll:focus {
  outline: 2px solid #36C0B6; /* Use your primary color */
  outline-offset: -2px;
}

/* Add scrollbar styling for visual users */
.horizontal-scroll {
  scroll-behavior: smooth; /* For smooth scrolling */
}
</style>
